import { TargetDay } from "@/components/masters/billingCycle/BillingDates";
import { fetchGet, fetchPost, fetchPatch, fetchDelete } from "@/lib/services";

export interface BillingDatePayload {
  From_Day: number;
  To_Day: number;
  Target_Day: number;
  Is_Active: boolean;
}

interface BillingDatesResponse {
  data: TargetDay[];
}

// States
export async function getStates(page?: number, search?: string,status?: string) {
  const params = new URLSearchParams();
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  if (status) params.append('Status', status);
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/states/${query}`);
}

export async function createState(data: { Name: string; State_Code: string }) {
  return await fetchPost("/states/", data);
}

export async function updateState(id: number, data: { Name: string; State_Code: string }) {
  return await fetchPatch(`/states/?Id=${id}`, data);
}

export async function toggleStateActive(id: number, data: { Is_Active: boolean }) {
  return await fetchPatch(`/states/?Id=${id}`, data);
} 

// Cities
export async function getCities(page?: number, search?: string,status?: string) {
  const params = new URLSearchParams();
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  if (status) params.append('Status', status);
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/cities/${query}`);
}

export async function createCity(data: { City_Name: string; State: string }) {
  return await fetchPost("/cities/", data);
}

export async function updateCity(id: number, data: { City_Name: string; State: string }) {
  return await fetchPatch(`/cities/?Id=${id}`, data);
}

export async function toggleCityActive(id: number, data: { Is_Active: boolean }) {
  return await fetchPatch(`/cities/?Id=${id}`, data);
}

// Schools
export async function getSchools(page?: number, search?: string, stateCode?: string, cityCode?: string ,Status?:string, Is_Active?: string) {
  const params = new URLSearchParams();
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  if (stateCode) params.append('State_Code', stateCode);
  if (cityCode) params.append('City_Code', cityCode);
  if (Status) params.append('Status', Status);
   if (Is_Active) params.append('Is_Active', String(Is_Active));
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/schools/${query}`);
}

export async function createSchool(data: any) {
  return await fetchPost("/schools/", data);
}

export async function updateSchool(id: number, data: any) {
  return await fetchPatch(`/schools/?Id=${id}`, data);
}

export async function toggleSchoolActive(id: number, data: { Is_Active: boolean }) {
  return await fetchPatch(`/schools/?Id=${id}`, data);
}

// Zones
export async function getZones(page?: number, search?: string,status?: string) {
  const params = new URLSearchParams();
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  if (status) params.append('Status', status);
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/zone/${query}`);
}

export async function createZone(data: { Name: string; Description?: string }) {
  return await fetchPost("/zone/", data);
}

export async function updateZone(id: number, data: { Name: string; Description?: string }) {
  return await fetchPatch(`/zone/?Id=${id}`, data);
}

export async function toggleZoneActive(id: number, data: { Is_Active: boolean }) {
  return await fetchPatch(`/zone/?Id=${id}`, data);
}

// Branches
export async function getBranches(page?: number, search?: string, branchCode?: string, zoneCode?: string, status?: string) {
  const params = new URLSearchParams();
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  if (branchCode) params.append('Branch_Code', branchCode);
  if (zoneCode) params.append('Zone_Code', zoneCode);
  if (status) params.append('Status', status);
  if (zoneCode) params.append('Zone_Code', zoneCode);
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/branches/${query}`);
}

export async function createBranch(data: any) {
  return await fetchPost("/branches/", data);
}

export async function updateBranch(id: number, data: any) {
  return await fetchPatch(`/branches/?Id=${id}`, data);
}

export async function toggleBranchActive(id: number, data: { Is_Active: boolean }) {
  return await fetchPatch(`/branches/?Id=${id}`, data);
}

export async function getMasterDropdownService(){
    return await fetchGet(`/masters/`);
}

// Roles
export async function getRoles(page?: number, search?: string,status?: string) {
  const params = new URLSearchParams();
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  if (status) params.append('Status', status);
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/roles/${query}`);
}

export async function createRole(data: { Name: string}) {
  return await fetchPost("/roles/", data);
}

export async function updateRole(id: number, data: { Name: string }) {
  return await fetchPatch(`/roles/?Id=${id}`, data);
}

export async function toggleRoleActive(id: number, data: { Is_Active: boolean }) {
  return await fetchPatch(`/roles/?Id=${id}`, data);
}

// Master Prices
export async function getMasterPrices(page?: number, search?: string) {
  const params = new URLSearchParams();
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/masterprices/${query}`);
}

export async function createMasterPrice(data: any) {
  return await fetchPost("/masterprices/", data);
}

export async function updateMasterPrice(id: number, data: any) {
  return await fetchPatch(`/masterprices/?Id=${id}`, data);
}

export async function deleteMasterPrice(id: number) {
  return await fetchDelete(`/masterprices/?Id=${id}`);
}

export async function getSubscriptionPlans(
  plan?: string,
  page?: number,
  state?: string,
  city?: string,
  search?: string,
) {
  const params = new URLSearchParams();
  if (plan) params.append('Plan', plan.trim());
  if (page && page > 1) params.append('page', String(page));
  if (state) params.append('State', state.trim());
  if (city) params.append('City', city.trim());
  if (search) params.append('Search', search.trim());
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/plans/${query}`);
}

export async function createSubscriptionPlan(data: any) {
  return await fetchPost("/plans/", data);
}

export async function updateSubscriptionPlan(id: number, data: any) {
  return await fetchPatch(`/plans/?Id=${id}`, data);
}

export async function deleteSubscriptionPlan(id: number) {
  return await fetchDelete(`/plans/?Id=${id}`);
}

export async function getSchoolsBasedOnState(state: string){
  return await fetchGet(`/stateschools/?State=${state}`);
}

export async function getCitiesBasedOnState(state: string){
  return await fetchGet(`/states_citiesdata/?State_Code=${state}`);
}

export async function getCitiesByState(state: string) {
  return await fetchGet(`/cities/?State=${state}`);
}

export async function getBranchesByStateAndCity( state: string, city: string ) {
  return await fetchGet(`/states_citiesdata/?State_Code=${state}&City_Code=${city}`)
}

export async function getZoneBranch(params: { State_Code?: string; City_Code?: string; Zone_Code?: string; Branch_Code?: string }) {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, v]) => !!v) as [string, string][]
  ).toString();
  return await fetchGet(`/zone-branch/${query ? '?' + query : ''}`);
}

export async function createRanges(data: any) {
  return await fetchPost("/ranges/", data);
}

export async function getRanges(page?: number, search?: string) {
  const params = new URLSearchParams();
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/ranges/${query}`);
}

export async function updateRange(id: number, data : any) {
  return await fetchPatch(`/ranges/?Id=${id}`, data);
}

export async function createMobileNumber(data: any) {
  return await fetchPost("/mobile-numbers/", data);
}

export async function getMobileNumbers(page?: number, search?: string,status?: string) {
  const params = new URLSearchParams();
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  if (status) params.append('Status', status.trim());
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/mobile-numbers/${query}`);
}

export async function updateMobileNumber(id: number, data : any) {
  return await fetchPatch(`/mobile-numbers/?Id=${id}`, data);
}

export async function getSubscriptionPlanHistory(page?: number, search?: string) {
  const params = new URLSearchParams();
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/SubscriptionPlanshistory/${query}`);
}

export async function getMasterPriceHistory(page?: number, search?: string) {
  const params = new URLSearchParams();
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/masterpriceshistory/${query}`);
}

// Role Permissions
export async function getRolePermissions(role?: string, page = 1) {
  const params = new URLSearchParams();
  if (role) params.append('Role', role.trim());
  if (page > 1) params.append('page', String(page));
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/roles-permissions/${query}`);
}

export async function createRolePermission(data: {
  Role: string;
  Screen_Name: string;
  Description?: string;
  Can_View: number;
  Can_Create: number;
  Can_Update: number;
  Can_Delete: number;
}) {
  return await fetchPost("/roles-permissions/", data);
}

export async function updateRolePermission(id: number, data: {
  Can_View?: number;
  Can_Create?: number;
  Can_Update?: number;
  Can_Delete?: number;
}) {
  return await fetchPatch(`/roles-permissions/?Id=${id}`, data);
}

// Screens Permissions (current user's effective permissions)
export async function getScreensPermissions() {
  return await fetchGet('/screens-permissions/');
}

// User Permissions
export async function getUserPermissions(userId?: number, page = 1) {
  const params = new URLSearchParams();
  if (userId) params.append('User', String(userId));
  if (page > 1) params.append('page', String(page));
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/user-permissions/${query}`);
}

export async function createUserPermission(data: {
  Screen_Name: string;
  User: number;
  Can_View: boolean;
  Can_Create: boolean;
  Can_Update: boolean;
  Can_Delete: boolean;
}) {
  return await fetchPost('/user-permissions/', data);
}

export async function updateUserPermission(id: number, data: {
  Can_View?: boolean;
  Can_Create?: boolean;
  Can_Update?: boolean;
  Can_Delete?: boolean;
}) {
  return await fetchPatch(`/user-permissions/?Id=${id}`, data);
}

export async function getBillingDates(
  page?: number
): Promise<BillingDatesResponse> {
  const params =
    new URLSearchParams();

  if (page && page > 1) {
    params.append(
      "page",
      String(page)
    );
  }

  const query =
    params.toString()
      ? `?${params}`
      : "";

  return (
    await fetchGet(
      `/billing-cycle/${query}`
    )
  ) as BillingDatesResponse;
}

export async function createBillingDate(
  data: BillingDatePayload
) {
  return fetchPost(
    "/billing-cycle/",
    data
  );
}

export async function updateBillingDate(
  id: number,
  data: BillingDatePayload
) {
  return fetchPatch(
    `/billing-cycle/?Id=${id}`,
    data
  );
}

export async function getUpcomingBirthdays() {
  return await fetchGet('/upcoming-birthdays/');
}

export async function getPaymentSummary(Year?: number, Month?: number, from_date?: string, to_date?: string, Pending_Details_Page?: number ,Paid_Details_Page?: number,page_size?: number) {
  const params = new URLSearchParams();
  if (Year) params.append('Year', String(Year));  
  if (Month) params.append('Month', String(Month));
  if (from_date) params.append('from_date', from_date);
  if (to_date) params.append('to_date', to_date);
  if (Pending_Details_Page) params.append('Pending_Details_Page', String(Pending_Details_Page));
  if (Paid_Details_Page) params.append('Paid_Details_Page', String(Paid_Details_Page));
  if (page_size) params.append('page_size', String(page_size));
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/payment-summary/${query}`);
}

export async function getPaymentList(Username?:string) {
  const params = new URLSearchParams();
  if (Username) params.append('Username', Username);
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/payment-list/${query}`);
}

export async function sendEmail(
  Username?: string,
  Child_Id?: string
) {
  const params = new URLSearchParams();
  if (Username) params.append("Username", Username);
  if (Child_Id) params.append("Child_Id", Child_Id);
  params.append("Mail_Status", "true");
  const query = params.toString() ? `?${params.toString()}` : "";
  return await fetchGet(`/payment-list/${query}`);
}